import nanoModal from 'nanomodal';

const buttonElement = document.getElementById('play-video');
const modalElement = document.getElementById('video-modal-1');
const iframe = modalElement.querySelector('iframe');


nanoModal.customShow = function (defaultShow, modalAPI) {
    defaultShow();

    modalAPI.overlay.el.style.display = 'none';
    modalAPI.modal.el.style.margin = 0;
};

const init = () => {
    if (!buttonElement || !modalElement || !iframe) {
        return;
    }
    
    buttonElement.addEventListener('click', () => {
        const closes = Array.from(modalElement.querySelectorAll('._close'));

        let modal = nanoModal(modalElement, {
            overlayClose: false,
            buttons: []
        });

        closes.forEach(close => {
            close.addEventListener('click', () => {
                if (typeof modal !== 'undefined') {
                    modal.hide();
                }
            });
        });
    
        modal.onShow(() => {
            document.body.classList.add('noscroll');
            iframe.setAttribute('src', iframe.dataset.src);
        });

        modal.onHide(() => {
            document.body.classList.remove('noscroll');
            iframe.removeAttribute('src');
            modal.remove();
            modal = undefined;
        });

        modal.show();
    });

    const iframeResize = () => {
        const width = parseInt(iframe.getAttribute('width'));
        const height = parseInt(iframe.getAttribute('height'));

        const wWidth = window.innerWidth;
        const wHeight = window.innerHeight;

        if (wHeight / wWidth > height / width) {
            iframe.style.width = wWidth + 'px';
            iframe.style.height = wWidth * (height / width) + 'px';
        } else {
            iframe.style.width = wHeight * (width / height) + 'px';
            iframe.style.height = wHeight + 'px';
        }
    };

    window.addEventListener('resize', iframeResize);
    iframeResize();
};

init();




// WEBPACK FOOTER //
// ./js/video-modal.js